/*
 * Runtime configuration accessor.
 *
 * Mirrors the Studio pattern (frontend/supabase.js) where config can arrive
 * either baked into the build (Vite env) OR injected at runtime onto window.*
 * by the backend's /runtime-config.js. For Build Task 1 there is no backend,
 * so every value safely resolves to a default and the app runs offline.
 *
 * Priority for each value: window.* (runtime) > import.meta.env (build) > default.
 */

function fromWindow(key) {
  if (typeof window === "undefined") return "";
  const value = window[key];
  return value === undefined || value === null ? "" : String(value).trim();
}

export const STUDIO_URL =
  fromWindow("__STUDIO_URL__") ||
  import.meta.env.VITE_STUDIO_URL ||
  "https://studio.513travel.com";

export const API_BASE_URL = (
  fromWindow("__API_BASE_URL__") ||
  import.meta.env.VITE_API_BASE_URL ||
  ""
).replace(/\/+$/, "");

export const SUPABASE_URL =
  fromWindow("__SUPABASE_URL__") || import.meta.env.VITE_SUPABASE_URL || "";

export const SUPABASE_PUBLISHABLE_KEY =
  fromWindow("__SUPABASE_PUBLISHABLE_KEY__") ||
  fromWindow("__SUPABASE_ANON_KEY__") ||
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
  "";

export const VISITOR_COUNTRY = fromWindow("__VISITOR_COUNTRY__");

export const SUPPORT_EMAIL =
  fromWindow("__SUPPORT_EMAIL__") ||
  import.meta.env.VITE_SUPPORT_EMAIL ||
  "hello@513travel.com";

// True only once a backend is actually wired (later task).
export const HAS_BACKEND = Boolean(API_BASE_URL);
